var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 601.556,
    height: 443.022,
    viewBox: "0 0 601.556 443.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_data-pana_1_",
    "data-name": "No data-pana (1)",
    transform: "translate(-86.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-202"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18233",
    "data-name": "Rectangle 18233",
    width: 134.99,
    height: 198.77,
    transform: "translate(107.683 197.316) rotate(-33.78)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6350",
    "data-name": "Path 6350",
    d: "M272.42,279.66l-1.27,7.88-55.78-8.04,1.27-7.88Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6351",
    "data-name": "Path 6351",
    d: "M244.33,251.55l8,1.15-8.87,54.92-8.01-1.16Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6352",
    "data-name": "Path 6352",
    d: "M193,181.75c.08.11-11.16,7.78-25.11,17.1s-25.32,16.8-25.4,16.68,11.16-7.78,25.11-17.11S192.87,181.63,193,181.75Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6353",
    "data-name": "Path 6353",
    d: "M234.22,171.39c.08.12-18.62,12.76-41.76,28.24s-42,27.93-42.06,27.82,18.6-12.77,41.77-28.25S234.14,171.27,234.22,171.39Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6354",
    "data-name": "Path 6354",
    d: "M242.49,183.75c.08.12-18.62,12.77-41.76,28.25s-42,27.93-42.06,27.81,18.62-12.76,41.77-28.25S242.41,183.63,242.49,183.75Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6355",
    "data-name": "Path 6355",
    d: "M250.76,196.12c.08.12-18.62,12.77-41.76,28.24s-42,27.94-42,27.82,18.61-12.77,41.76-28.25S250.68,196,250.76,196.12Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6356",
    "data-name": "Path 6356",
    d: "M259,208.49c.08.12-18.62,12.76-41.76,28.24s-42,27.93-42.05,27.81S193.83,251.78,217,236.3,259,208.37,259,208.49Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18234",
    "data-name": "Rectangle 18234",
    width: 113.37,
    height: 166.93,
    transform: "translate(500.84 295.997) rotate(-33.78)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6357",
    "data-name": "Path 6357",
    d: "M639.2,365.18l-1.07,6.62-46.85-6.75,1.08-6.62Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6358",
    "data-name": "Path 6358",
    d: "M615.61,341.57l6.72.97-7.45,46.12-6.73-.97Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6359",
    "data-name": "Path 6359",
    d: "M572.46,283c.08.12-9.35,6.57-21.07,14.4s-21.28,14.09-21.36,14,9.36-6.56,21.07-14.4S572.38,282.83,572.46,283Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6360",
    "data-name": "Path 6360",
    d: "M607.11,274.25c.08.12-15.61,10.76-35,23.75s-35.26,23.45-35.34,23.33,15.61-10.76,35-23.76S607,274.13,607.11,274.25Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6361",
    "data-name": "Path 6361",
    d: "M614.06,284.63c.08.12-15.61,10.76-35,23.76s-35.26,23.44-35.34,23.32,15.56-10.71,35-23.71S614,284.52,614.06,284.63Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6362",
    "data-name": "Path 6362",
    d: "M621,295c.08.12-15.62,10.76-35,23.76s-35.26,23.44-35.34,23.32,15.61-10.75,35-23.76S620.93,294.9,621,295Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6363",
    "data-name": "Path 6363",
    d: "M628,305.41c.08.12-15.61,10.75-35,23.75s-35.26,23.44-35.34,23.33,15.61-10.76,35-23.76S627.87,305.29,628,305.41Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18235",
    "data-name": "Rectangle 18235",
    width: 116.6,
    height: 171.69,
    transform: "translate(343.174 73.349) rotate(28.14)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6364",
    "data-name": "Path 6364",
    d: "M347.42,232.37l-6.52,2.23-16.56-45.77,6.53-2.24Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6365",
    "data-name": "Path 6365",
    d: "M357.42,199.53l2.38,6.57-45.46,15.57-2.38-6.57Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6366",
    "data-name": "Path 6366",
    d: "M389.72,132c-.08.15-10.5-5.27-23.29-12.1s-23.08-12.5-23-12.65,10.51,5.27,23.3,12.1S389.8,131.84,389.72,132Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6367",
    "data-name": "Path 6367",
    d: "M414.4,159.23c-.08.15-17.34-8.93-38.55-20.27s-38.33-20.66-38.25-20.81,17.33,8.92,38.54,20.27S414.48,159.08,414.4,159.23Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6368",
    "data-name": "Path 6368",
    d: "M408.34,170.56c-.08.15-17.34-8.92-38.55-20.27s-38.33-20.66-38.25-20.81,17.33,8.93,38.54,20.27S408.42,170.41,408.34,170.56Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6369",
    "data-name": "Path 6369",
    d: "M402.28,181.89c-.08.15-17.34-8.92-38.55-20.26S325.4,141,325.48,140.82s17.33,8.92,38.54,20.26S402.36,181.74,402.28,181.89Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6370",
    "data-name": "Path 6370",
    d: "M396.22,193.22c-.08.15-17.34-8.92-38.55-20.26s-38.34-20.66-38.25-20.81,17.33,8.92,38.54,20.26S396.3,193.07,396.22,193.22Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18236",
    "data-name": "Rectangle 18236",
    width: 2.58,
    height: 43.98,
    transform: "translate(394.17)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6371",
    "data-name": "Path 6371",
    d: "M335.23,97.19H455.69S444.57,44,394.55,44C350.06,44,335.23,97.19,335.23,97.19Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18237",
    "data-name": "Rectangle 18237",
    width: 2.58,
    height: 43.98,
    transform: "translate(394.17)",
    fill: "#fd0113"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6372",
    "data-name": "Path 6372",
    d: "M663.67,439.83c0,.14-129.25.26-288.66.26S86.33,440,86.33,439.83s129.23-.26,288.68-.26S663.67,439.68,663.67,439.83Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6373",
    "data-name": "Path 6373",
    d: "M118.29,377.2a12.62,12.62,0,0,1,8.78,4.5,22.15,22.15,0,0,1,4.47,9c1.69,6.32.65,13.79-1.15,20.08-6.84-2.45-11.07-9.75-13-13.59-3-6.06-4.79-18.86.87-20",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6374",
    "data-name": "Path 6374",
    d: "M140.24,418.45a10.74,10.74,0,0,1-.5-10.78,14.26,14.26,0,0,1,8.6-6.91c1.67-.52,3.61-.73,5.06.24a4.58,4.58,0,0,1,1.77,4.31,9.27,9.27,0,0,1-2,4.42c-3.33,4.51-7.37,8.26-13,8.72",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6375",
    "data-name": "Path 6375",
    d: "M141,439.58a6.5,6.5,0,0,1-.31-1.31c-.18-.94-.42-2.15-.71-3.6a37.77,37.77,0,0,1-.74-12.11,23,23,0,0,1,4.49-11.21,15.317,15.317,0,0,1,2.59-2.63,9.16,9.16,0,0,1,.82-.58,1.149,1.149,0,0,1,.3-.18,25.368,25.368,0,0,0-3.45,3.59,23.85,23.85,0,0,0-4.28,11.08c-.64,4.66.15,8.93.61,12,.24,1.53.44,2.77.55,3.63A8.227,8.227,0,0,1,141,439.58Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6376",
    "data-name": "Path 6376",
    d: "M120.49,386.83a2.339,2.339,0,0,1,.28.51c.18.4.42.9.7,1.53.61,1.33,1.46,3.26,2.49,5.65,2.06,4.79,4.82,11.45,7.7,18.87s5.33,14.19,7,19.12c.86,2.46,1.53,4.46,2,5.85.21.66.37,1.19.5,1.6a2.611,2.611,0,0,1,.15.57,2.459,2.459,0,0,1-.24-.54c-.15-.4-.34-.92-.59-1.57l-2.11-5.8c-1.79-4.89-4.29-11.65-7.16-19.06s-5.59-14.09-7.57-18.91c-1-2.37-1.77-4.3-2.34-5.71-.26-.64-.47-1.15-.63-1.56a3.49,3.49,0,0,1-.18-.55Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6377",
    "data-name": "Path 6377",
    d: "M132.87,425.6a25.18,25.18,0,0,0-19.52-12.13c-2-.14-4.46.2-5.36,2s.3,4,1.68,5.46a21.49,21.49,0,0,0,23.27,5.2",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6378",
    "data-name": "Path 6378",
    d: "M116.43,418.89a7.144,7.144,0,0,1,1.27.05,12.084,12.084,0,0,1,1.47.17c.57.11,1.24.17,1.94.37a19.409,19.409,0,0,1,2.31.64,22.9,22.9,0,0,1,2.57,1,27.8,27.8,0,0,1,5.42,3.21,27.31,27.31,0,0,1,4.48,4.44,22.486,22.486,0,0,1,1.57,2.25,21.93,21.93,0,0,1,1.18,2.09,17.4,17.4,0,0,1,.8,1.8,11.343,11.343,0,0,1,.51,1.4,6.82,6.82,0,0,1,.33,1.23c-.11,0-.59-1.72-1.94-4.28a21.992,21.992,0,0,0-1.21-2,25.327,25.327,0,0,0-1.58-2.19,26.65,26.65,0,0,0-9.74-7.52c-.87-.38-1.7-.74-2.51-1a21.868,21.868,0,0,0-2.27-.69C118.23,419.09,116.42,419,116.43,418.89Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6379",
    "data-name": "Path 6379",
    d: "M570.36,105.48c-2.94.67-4.37,4.06-4.65,7.06s.1,6.18-1.16,8.92c-1.42,3.08-4.81,5.36-4.92,8.75-.07,2.07,1.16,4,1.1,6.09-.1,3.4-3.56,6-3.75,9.36-.13,2.45,1.5,4.79,1.11,7.21-.3,1.88-1.77,3.36-2.39,5.16-1.23,3.6,1.24,7.55,4.45,9.57a14.59,14.59,0,0,0,21.25-6.78c1.78-4.32,1.39-9.19,1-13.84q-1.8-21.76-2.68-43.58",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6380",
    "data-name": "Path 6380",
    d: "M561.82,156.66a3.41,3.41,0,0,0,1.35-1.59,5.791,5.791,0,0,0,.34-2.45,13.467,13.467,0,0,0-.73-3.23,9.31,9.31,0,0,1-.52-4.1c.25-1.56,1.37-2.84,2.38-4.1a8.77,8.77,0,0,0,1.35-2.05,3.31,3.31,0,0,0,.16-2.4c-.52-1.63-2.12-2.83-2.85-4.72a5,5,0,0,1-.16-2.92,11.59,11.59,0,0,1,1-2.61,22.409,22.409,0,0,0,2-4.71c.7-3.17.37-6.2.85-8.69a9.62,9.62,0,0,1,2.53-5.32,5.81,5.81,0,0,1,1.32-1,2.07,2.07,0,0,1,.53-.19,7.691,7.691,0,0,0-1.71,1.28,9.78,9.78,0,0,0-2.31,5.25,32.558,32.558,0,0,0-.28,4,24.625,24.625,0,0,1-.46,4.69,22.466,22.466,0,0,1-2,4.82c-.75,1.57-1.44,3.41-.78,5.13s2.25,2.91,2.86,4.75a3.88,3.88,0,0,1-.19,2.75,9.461,9.461,0,0,1-1.5,2.25c-1,1.26-2.09,2.46-2.33,3.86a9,9,0,0,0,.46,3.93,13.622,13.622,0,0,1,.66,3.32,5.61,5.61,0,0,1-.45,2.54,3.06,3.06,0,0,1-1,1.26A1.58,1.58,0,0,1,561.82,156.66Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6381",
    "data-name": "Path 6381",
    d: "M554,180.37l-9,26-37.64,2-6.28,14,39.3,4A14.85,14.85,0,0,0,560,217.64l10.49-29.28Z",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6382",
    "data-name": "Path 6382",
    d: "M631.81,425.7s-27.58-87.62-28.17-90.46c-.53-2.58,10-65.63,11.34-82l-37.27,1.39V255l-15.84.88L576.05,435H593.2l-1.7-59.45c10.58,28.39,25.74,57.33,25.74,57.33Z",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6383",
    "data-name": "Path 6383",
    d: "M592.2,396.88c0-.54-.21-19.92-.21-19.92-.21,1.16-6.57-16.82-6.42-17.91C585.65,358.48,592.2,396.88,592.2,396.88Z",
    fill: "#a36957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6384",
    "data-name": "Path 6384",
    d: "M584.85,350.53a3.881,3.881,0,0,0-.11,1.09,27.147,27.147,0,0,0,0,3,19.957,19.957,0,0,0,.17,2.05c.08.74.19,1.52.36,2.33a41.369,41.369,0,0,0,1.41,5.22c1.24,3.63,2.62,6.8,3.59,9.1.46,1,.86,1.95,1.2,2.71a4.321,4.321,0,0,0,.5,1,3.789,3.789,0,0,0-.3-1c-.23-.66-.58-1.61-1-2.78-.88-2.34-2.2-5.54-3.43-9.13a43.337,43.337,0,0,1-1.43-5.14c-.18-.8-.3-1.57-.41-2.29s-.19-1.4-.24-2c-.12-1.24-.17-2.24-.2-2.94a4.519,4.519,0,0,0-.11-1.22Z",
    fill: "#a36957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6385",
    "data-name": "Path 6385",
    d: "M575.73,435.91V434.3l17.57-.77.05,6.65-1.08.07c-4.83.28-24.55,1.1-27.77.13C560.89,439.3,575.73,435.91,575.73,435.91Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6386",
    "data-name": "Path 6386",
    d: "M593.58,439.78a2.288,2.288,0,0,1-.3,0l-.86.06-3.18.14c-2.68.11-6.39.21-10.48.23s-7.81-.05-10.5-.13l-3.17-.13h-1.17a1.851,1.851,0,0,1,.3,0h.87l3.18.06c2.68,0,6.39.08,10.48.06s7.81-.09,10.49-.16l3.18-.08h1.16Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6387",
    "data-name": "Path 6387",
    d: "M570,440.34a7.67,7.67,0,0,0-.6-1.51,7.207,7.207,0,0,0-1.09-1.21,2.32,2.32,0,0,1,1.27,1.1A2.39,2.39,0,0,1,570,440.34Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6388",
    "data-name": "Path 6388",
    d: "M575.18,437.71a3.957,3.957,0,0,1-.55-.67c-.26-.4-.42-.75-.37-.78s.29.26.55.66S575.23,437.68,575.18,437.71Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6389",
    "data-name": "Path 6389",
    d: "M576.6,437c0,.05-.32-.14-.62-.41s-.52-.52-.48-.56.32.14.62.41S576.64,436.91,576.6,437Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6390",
    "data-name": "Path 6390",
    d: "M577.49,435.3a2.11,2.11,0,0,1-.92.12,2,2,0,0,1-.91-.09,2.081,2.081,0,0,1,.91-.12,2,2,0,0,1,.92.09Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6391",
    "data-name": "Path 6391",
    d: "M577.79,434.14a1.859,1.859,0,0,1-1,.3,1.89,1.89,0,0,1-1-.14,5.769,5.769,0,0,1,1-.08,5.19,5.19,0,0,1,1-.08Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6392",
    "data-name": "Path 6392",
    d: "M574.59,436.18a3.069,3.069,0,0,1-1.13,0,6.462,6.462,0,0,1-1.19-.26,3.23,3.23,0,0,1-.69-.28.63.63,0,0,1-.28-.35.44.44,0,0,1,.17-.45,2.08,2.08,0,0,1,2.92,1.35.759.759,0,0,1,0,.3,3.221,3.221,0,0,0-.52-1,2.06,2.06,0,0,0-1-.62,1.78,1.78,0,0,0-1.34.1c-.17.13-.1.34.09.46a3.609,3.609,0,0,0,.64.27,8.412,8.412,0,0,0,1.15.29C574.16,436.15,574.59,436.15,574.59,436.18Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6393",
    "data-name": "Path 6393",
    d: "M574.3,436.24a1.06,1.06,0,0,1-.14-.78,1.86,1.86,0,0,1,.31-.82,1.14,1.14,0,0,1,.93-.58.46.46,0,0,1,.35.52,1.189,1.189,0,0,1-.19.5,4.13,4.13,0,0,1-.53.69,1.64,1.64,0,0,1-.64.45,7.042,7.042,0,0,0,.53-.56,3.879,3.879,0,0,0,.47-.67c.15-.24.26-.67,0-.72s-.56.26-.73.48a1.829,1.829,0,0,0-.32.73,3.52,3.52,0,0,0-.04.76Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6394",
    "data-name": "Path 6394",
    d: "M593.21,435s-.5,0-1.29.05a5.54,5.54,0,0,0-4.57,3.67c-.26.75-.28,1.26-.32,1.25s0-.13,0-.35a4.488,4.488,0,0,1,.18-.95,5.47,5.47,0,0,1,1.76-2.61,5.389,5.389,0,0,1,2.93-1.15,4.189,4.189,0,0,1,1,0A1.26,1.26,0,0,1,593.21,435Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6395",
    "data-name": "Path 6395",
    d: "M584.8,438.38a9.81,9.81,0,0,1-2.56.25,9.429,9.429,0,0,1-2.55-.22c0-.06,1.14,0,2.55,0S584.79,438.32,584.8,438.38Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6396",
    "data-name": "Path 6396",
    d: "M588.22,438.35s-.09.24-.21.5-.18.5-.24.49-.09-.27.05-.58S588.18,438.3,588.22,438.35Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6397",
    "data-name": "Path 6397",
    d: "M589.51,436.74a1.109,1.109,0,0,1-.25.4c-.18.18-.36.3-.41.26s.07-.22.25-.41S589.46,436.69,589.51,436.74Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6398",
    "data-name": "Path 6398",
    d: "M591.35,436c0,.06-.24.06-.5.15s-.44.23-.49.19.1-.28.42-.39S591.37,435.94,591.35,436Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6399",
    "data-name": "Path 6399",
    d: "M592.66,435.64c0,.06-.07.15-.22.2s-.28.06-.3,0,.08-.15.22-.2S592.64,435.59,592.66,435.64Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6400",
    "data-name": "Path 6400",
    d: "M616.89,434.36l-.66-1.47L631.94,425l2.77,6-1,.51c-4.29,2.23-21.94,11.05-25.28,11.49C604.74,443.53,616.89,434.36,616.89,434.36Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6401",
    "data-name": "Path 6401",
    d: "M634.77,430.57l-.26.16-.77.4-2.84,1.44c-2.4,1.19-5.74,2.8-9.47,4.5s-7.15,3.15-9.63,4.18l-2.95,1.19-.8.31a1.138,1.138,0,0,1-.29.09l.27-.13.79-.35,2.92-1.25c2.47-1.06,5.87-2.54,9.6-4.24s7.08-3.28,9.5-4.44l2.86-1.37.79-.37Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6402",
    "data-name": "Path 6402",
    d: "M613.52,440.74a7.379,7.379,0,0,0-1.17-1.14,6.94,6.94,0,0,0-1.49-.66,2.81,2.81,0,0,1,2.66,1.8Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6403",
    "data-name": "Path 6403",
    d: "M617.13,436.22a3.583,3.583,0,0,1-.78-.38c-.4-.26-.69-.51-.66-.56s.38.12.78.38S617.16,436.17,617.13,436.22Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6404",
    "data-name": "Path 6404",
    d: "M618.11,435c0,.05-.34,0-.73-.12s-.68-.27-.67-.33a1.49,1.49,0,0,1,.74.12C617.83,434.76,618.13,434.9,618.11,435Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6405",
    "data-name": "Path 6405",
    d: "M618.25,433.08a2.334,2.334,0,0,1-.79.49,2.109,2.109,0,0,1-.87.29,2.357,2.357,0,0,1,.78-.49A2.18,2.18,0,0,1,618.25,433.08Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6406",
    "data-name": "Path 6406",
    d: "M618.05,431.9a2.723,2.723,0,0,1-.81.69,1.74,1.74,0,0,1-1,.3,5.287,5.287,0,0,1,.91-.49C617.64,432.13,618,431.85,618.05,431.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6407",
    "data-name": "Path 6407",
    d: "M616,435.08a3.239,3.239,0,0,1-1,.46,7.85,7.85,0,0,1-1.2.25,3,3,0,0,1-.74,0,.59.59,0,0,1-.4-.2.44.44,0,0,1,0-.48,2.06,2.06,0,0,1,2.57-.5,2,2,0,0,1,.64.53c.12.16.17.26.16.27a3,3,0,0,0-.87-.67,2,2,0,0,0-1.13-.17,1.75,1.75,0,0,0-1.18.64c-.11.19,0,.35.27.38a4,4,0,0,0,.69,0,7.9,7.9,0,0,0,1.18-.21C615.56,435.22,616,435.05,616,435.08Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6408",
    "data-name": "Path 6408",
    d: "M615.72,435.25a1.11,1.11,0,0,1-.44-.66,1.88,1.88,0,0,1-.06-.87,1.13,1.13,0,0,1,.62-.91c.25-.08.83.43.87.62s-.29.09-.31.25a3.481,3.481,0,0,1-.2.83,1.56,1.56,0,0,1-.4.68,7.305,7.305,0,0,0,.26-.72,5.127,5.127,0,0,0,.15-.81c0-.28,0-.71-.32-.64s-.41.46-.48.74a1.731,1.731,0,0,0,0,.79A4.367,4.367,0,0,0,615.72,435.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6409",
    "data-name": "Path 6409",
    d: "M632.47,426.36a7.1,7.1,0,0,0-1.16.58,5.45,5.45,0,0,0-2.66,5.22c.06.8.25,1.26.21,1.28a1.267,1.267,0,0,1-.15-.32,5.182,5.182,0,0,1-.21-.94,5.29,5.29,0,0,1,2.73-5.36,4.749,4.749,0,0,1,.89-.38,1.229,1.229,0,0,1,.35-.08Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6410",
    "data-name": "Path 6410",
    d: "M626.18,432.9a14.28,14.28,0,0,1-4.65,2.12c0-.06,1.05-.46,2.33-1S626.15,432.85,626.18,432.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6411",
    "data-name": "Path 6411",
    d: "M629.29,431.47c.05,0,0,.25,0,.54v.55a.817.817,0,0,1-.2-.55C629.09,431.68,629.24,431.44,629.29,431.47Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6412",
    "data-name": "Path 6412",
    d: "M629.8,429.47c.05,0,0,.23-.06.47s-.21.42-.26.4,0-.23.06-.47S629.74,429.45,629.8,429.47Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6413",
    "data-name": "Path 6413",
    d: "M631.18,428c0,.06-.2.15-.4.34s-.31.39-.36.37,0-.3.22-.53A.657.657,0,0,1,631.18,428Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6414",
    "data-name": "Path 6414",
    d: "M632.23,427.18a.4.4,0,0,1-.12.27c-.12.11-.23.17-.27.13s0-.16.12-.27S632.19,427.14,632.23,427.18Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6415",
    "data-name": "Path 6415",
    d: "M612.56,223.64l-2.92-35.7,15,.27s.69-5.27-1.52-16.81c-1.36-7.08-6.07-11.42-11.36-14v-.1l-.46-.12a42.829,42.829,0,0,0-13.76-3.59l-18.45.21S565,152,557.23,162.09c-3,3.87-12.31,30.36-12.31,30.36l22.15,10.66L565,188.42s.42,10.65,1.78,14c.75,1.88,3,7.72,3,7.72l-.29,17.62Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6416",
    "data-name": "Path 6416",
    d: "M602.39,182.76l-2.74,11.66h25.83l-1.7-19.56Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6417",
    "data-name": "Path 6417",
    d: "M625.48,194.42a20.7,20.7,0,0,0-3.42-.34c-2.12-.12-5-.23-8.28-.21s-6.17.16-8.29.32a19.6,19.6,0,0,0-3.41.42,21.661,21.661,0,0,0,3.44,0c2.11-.07,5-.15,8.26-.16s6.15,0,8.27.05a21.647,21.647,0,0,0,3.43-.08Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6418",
    "data-name": "Path 6418",
    d: "M601.27,174.77a15.576,15.576,0,0,0-.08,3c0,1.83.08,4.35.19,7.14s.24,5.32.36,7.14a14.9,14.9,0,0,0,.32,3,15.636,15.636,0,0,0,.08-3c0-1.83-.08-4.36-.19-7.15s-.24-5.31-.36-7.14A14.705,14.705,0,0,0,601.27,174.77Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10792",
    "data-name": "Group 10792",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6419",
    "data-name": "Path 6419",
    d: "M577.77,184.87s5.74,42.57,21.88,41.44c0,0,7.27-.08,9.6-4.91v-1.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10793",
    "data-name": "Group 10793",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6420",
    "data-name": "Path 6420",
    d: "M601.27,177.28l-3.09,20.87,2,3.66,3.3-7.16-1.4-.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6421",
    "data-name": "Path 6421",
    d: "M569.69,210.16a4,4,0,0,1-.44-1c-.25-.65-.58-1.6-1-2.79a86.119,86.119,0,0,1-2.47-9.45,67,67,0,0,1-1.22-9.69c-.06-1.25-.08-2.26-.06-3a4,4,0,0,1,.07-1.08c.08,0,.14,1.54.35,4a88.992,88.992,0,0,0,1.37,9.61c.74,3.72,1.63,7.05,2.31,9.44.32,1.11.59,2.06.81,2.84a4.89,4.89,0,0,1,.28,1.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6422",
    "data-name": "Path 6422",
    d: "M576.21,222.39a5.162,5.162,0,0,1-.89-2,4.8,4.8,0,0,1-.39-2.2,5.22,5.22,0,0,1,.89,2.05A5,5,0,0,1,576.21,222.39Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6423",
    "data-name": "Path 6423",
    d: "M578.44,222.23a9.2,9.2,0,0,1-.09-6.24,20.812,20.812,0,0,1,0,3.12A20.557,20.557,0,0,1,578.44,222.23Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6424",
    "data-name": "Path 6424",
    d: "M567.52,203.6c-.07.12-5.22-2.32-11.51-5.46s-11.34-5.8-11.28-5.93,5.22,2.32,11.51,5.46S567.58,203.47,567.52,203.6Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6425",
    "data-name": "Path 6425",
    d: "M576.6,157.25c.11-5.06.14-10.38.14-10.38s-6.49-1.25-7.62-9.79c-1.08-8.14,1.94-27.25,1.94-27.25h0c9.48-3.58,19.33-.33,25.82,7.35h0l-1.61,41.07c-.19,4.77-4.44,8.41-9.54,8.17h0C580.57,166.17,576.49,162.07,576.6,157.25Z",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6426",
    "data-name": "Path 6426",
    d: "M570.56,125.1a1.1,1.1,0,0,0,1,1.13,1.05,1.05,0,0,0,1.15-1,1.09,1.09,0,0,0-1-1.12,1,1,0,0,0-1.15.99Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6427",
    "data-name": "Path 6427",
    d: "M570.16,123.67c.13.14,1-.45,2.15-.41s2,.64,2.14.5-.06-.32-.43-.61a3,3,0,0,0-1.72-.57,2.81,2.81,0,0,0-1.71.5C570.22,123.35,570.09,123.6,570.16,123.67Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6428",
    "data-name": "Path 6428",
    d: "M582.47,125.84a1.09,1.09,0,0,0,1,1.13,1,1,0,0,0,1.15-1,1.08,1.08,0,0,0-1-1.12,1,1,0,0,0-1.15.99Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6429",
    "data-name": "Path 6429",
    d: "M582.39,124.41c.13.15,1-.44,2.15-.41s2,.64,2.15.5-.07-.32-.44-.6a2.87,2.87,0,0,0-1.71-.58,2.91,2.91,0,0,0-1.72.5C582.46,124.09,582.33,124.34,582.39,124.41Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6430",
    "data-name": "Path 6430",
    d: "M577.91,133a7.559,7.559,0,0,0-1.9-.39c-.3,0-.58-.11-.62-.31a1.46,1.46,0,0,1,.22-.89l.94-2.25a39.11,39.11,0,0,0,2.15-5.92,39.622,39.622,0,0,0-2.62,5.73c-.31.79-.62,1.55-.91,2.27a1.75,1.75,0,0,0-.18,1.17.75.75,0,0,0,.48.46,2.051,2.051,0,0,0,.51.08A7.629,7.629,0,0,0,577.91,133Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6431",
    "data-name": "Path 6431",
    d: "M576.74,146.87a21.66,21.66,0,0,0,11.46-2.75s-2.91,5.77-11.4,4.76Z",
    fill: "#a36957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6432",
    "data-name": "Path 6432",
    d: "M586.15,121c-.24.37-1.14.21-2.14,0s-1.88-.38-2-.81.93-1,2.27-.73S586.39,120.68,586.15,121Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6433",
    "data-name": "Path 6433",
    d: "M574.48,119.3c-.09.43-1.05.59-2.15.64s-2.07,0-2.2-.44.8-1.06,2.13-1.12S574.57,118.89,574.48,119.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6434",
    "data-name": "Path 6434",
    d: "M577.93,135.81a.58.58,0,0,0-.65.3.658.658,0,1,0,.4-.33",
    fill: "#a36957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6435",
    "data-name": "Path 6435",
    d: "M578.2,135.93c0-.05-.19-.34-.7-.23a.9.9,0,0,0-.64.63.959.959,0,0,0,1.48,1.06.84.84,0,0,0,.36-.83c-.1-.53-.49-.61-.51-.54s.14.25.11.56a.47.47,0,0,1-.24.37.51.51,0,0,1-.51,0,.53.53,0,0,1-.18-.49.49.49,0,0,1,.27-.37C577.92,135.92,578.17,136,578.2,135.93Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6436",
    "data-name": "Path 6436",
    d: "M593,127.21c-1,2.34-3.48,4.15-3.14,6.68.22,1.63,1.27,3.15,1.07,4.79-.26,2-2.39,3.48-2.7,5.53-.37,2.51,2.08,4.46,3.05,6.8,1.43,3.42-.39,7.26-.44,11a11.74,11.74,0,0,0,10.4,11.42c2.28.19,4.85-.5,6-2.46,1-1.62.78-3.68,1.36-5.47.88-2.68,3.43-4.64,4-7.4,1-5-5.1-9.2-4.7-14.32.17-2.19,1.52-4.09,2.09-6.21a9.12,9.12,0,0,0-1.78-8.09c-1.51-1.79-3.69-3-5-4.92-1.45-2.21-1.5-5-2-7.61a19.18,19.18,0,0,0-30.46-11.23s-1.45,6.59,5.32,7.7,9.9-.17,10.66,2.54a7.16,7.16,0,0,0,2,6.19C591.49,125.13,594.12,124.49,593,127.21Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6437",
    "data-name": "Path 6437",
    d: "M603.75,172.92a2.389,2.389,0,0,1-.62-.06,9.777,9.777,0,0,1-1.72-.47,12.21,12.21,0,0,1-5.24-3.87,13.86,13.86,0,0,1-2.22-4,15.851,15.851,0,0,1-.91-5.13,21.19,21.19,0,0,1,.72-5.71,24.451,24.451,0,0,1,1-2.89,29.543,29.543,0,0,0,1.09-2.87,5.34,5.34,0,0,0,0-2.94,16.3,16.3,0,0,0-1.13-2.74,18,18,0,0,1-1.17-2.71,5.85,5.85,0,0,1-.21-2.87c.4-1.88,1.54-3.28,2.22-4.71a8.91,8.91,0,0,0,.9-4.26,10.05,10.05,0,0,0-2.23-5.9,17.584,17.584,0,0,0-1.69-1.65,6.84,6.84,0,0,1,1.85,1.52,10,10,0,0,1,2.44,6,9.241,9.241,0,0,1-.88,4.46c-.69,1.48-1.8,2.89-2.14,4.61s.47,3.53,1.36,5.27a15.58,15.58,0,0,1,1.18,2.83,5.89,5.89,0,0,1,0,3.2A31.349,31.349,0,0,1,595.2,151a23.524,23.524,0,0,0-1,2.83,20.611,20.611,0,0,0-.73,5.57,14.461,14.461,0,0,0,2.94,8.88,12.28,12.28,0,0,0,5,3.91C602.9,172.77,603.76,172.86,603.75,172.92Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6438",
    "data-name": "Path 6438",
    d: "M602.75,122.46a7.069,7.069,0,0,1-1.49.22,15.51,15.51,0,0,1-4.12-.11,7.85,7.85,0,0,1-5.2-3.15,17,17,0,0,1-1.36-3.36,5.58,5.58,0,0,0-2.28-2.81c-2.19-1.39-4.76-1.56-7-1.83a12.21,12.21,0,0,1-5.83-1.82,5.77,5.77,0,0,1-2.39-3.33,3.35,3.35,0,0,1-.07-1.13c0-.26.06-.39.08-.39a7.081,7.081,0,0,0,.19,1.47,5.72,5.72,0,0,0,2.4,3.08,12.09,12.09,0,0,0,5.67,1.64c2.24.26,4.9.39,7.24,1.87a6.08,6.08,0,0,1,2.48,3.07,16.735,16.735,0,0,0,1.29,3.28,7.55,7.55,0,0,0,4.86,3,17.261,17.261,0,0,0,4,.27,10.113,10.113,0,0,1,1.53.03Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6439",
    "data-name": "Path 6439",
    d: "M600.27,114.32a3.33,3.33,0,0,1-1.17.17,7.13,7.13,0,0,1-5-2,9.18,9.18,0,0,1-1.55-2.07c-.9-1.52-1.77-3.39-3.64-4.17a12,12,0,0,0-5.6-.49,17.18,17.18,0,0,1-4.78,0,6,6,0,0,1-3-1.32,3.322,3.322,0,0,1-.58-.66q-.18-.26-.15-.27a6.674,6.674,0,0,0,.86.77,6.3,6.3,0,0,0,2.89,1.12,18.139,18.139,0,0,0,4.68-.08,12,12,0,0,1,5.85.5,5.75,5.75,0,0,1,2.39,2,25.755,25.755,0,0,1,1.45,2.42,9.521,9.521,0,0,0,1.45,2,7,7,0,0,0,1.71,1.27,7.42,7.42,0,0,0,3,.83A7.715,7.715,0,0,1,600.27,114.32Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6440",
    "data-name": "Path 6440",
    d: "M606.73,170.76c-.05,0,.27-.66.64-1.9a17.2,17.2,0,0,0,.66-5.36,16.321,16.321,0,0,0-2.13-7.63c-.73-1.31-1.84-2.48-2.75-3.92a7,7,0,0,1-1-2.41,5.389,5.389,0,0,1,.22-2.7c.56-1.73,1.56-3.18,1.78-4.77a6.913,6.913,0,0,0-1.3-4.33,21.283,21.283,0,0,1-1.07-2,7.32,7.32,0,0,1-.57-2.09,18.118,18.118,0,0,1,.12-3.81,10.11,10.11,0,0,0-.48-5.32,4.84,4.84,0,0,0-1.18-1.56.208.208,0,0,1,.12.06,1.22,1.22,0,0,1,.32.23,3.57,3.57,0,0,1,.93,1.19,9.88,9.88,0,0,1,.65,5.43,19.172,19.172,0,0,0-.05,3.73,9.6,9.6,0,0,0,1.62,3.88,13.3,13.3,0,0,1,1.09,2.13,5,5,0,0,1,.3,2.52c-.24,1.75-1.27,3.23-1.79,4.86a5,5,0,0,0-.21,2.45,6.66,6.66,0,0,0,.94,2.23c.85,1.39,2,2.58,2.73,3.95a16.5,16.5,0,0,1,2.08,7.87,16.18,16.18,0,0,1-.84,5.43,10.422,10.422,0,0,1-.58,1.38,1.839,1.839,0,0,1-.25.46Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6441",
    "data-name": "Path 6441",
    d: "M566,357.09s-6.74-63.84-7.13-87.43,10.61-46.87,10.61-46.87L612.56,221s8.52,23.93,8.67,34c.3,19.54-5.19,38.83-4.56,54.33l1.44,47.8",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6442",
    "data-name": "Path 6442",
    d: "M619.56,278.6a6.881,6.881,0,0,1-.71.54l-.39.27-.42.41a6.919,6.919,0,0,0-1,1.07c-1.39,1.7-2.4,4.75-3.37,8.54a28.7,28.7,0,0,1-2.18,6.08,10.638,10.638,0,0,1-1,1.51c-.18.24-.35.5-.56.73l-.66.66a10.71,10.71,0,0,1-3.24,2.08c-2.41,1.06-5.14,1.56-7.62,2.81a12,12,0,0,0-5.53,6.3c-1.22,2.71-2,5.55-3,8.21a14.8,14.8,0,0,1-4.5,6.82,12.36,12.36,0,0,1-7,2.21c-2.32.14-4.47.07-6.4.36a10.11,10.11,0,0,0-4.82,1.82,6.76,6.76,0,0,0-2.24,3.16,4.8,4.8,0,0,0-.17,2.45c.12.56.27.83.24.84a2.52,2.52,0,0,1-.34-.82,4.591,4.591,0,0,1,.08-2.53,6.8,6.8,0,0,1,2.25-3.33,10.25,10.25,0,0,1,5-2c2-.32,4.13-.28,6.42-.43a12,12,0,0,0,6.79-2.16,14.52,14.52,0,0,0,4.31-6.62c1-2.63,1.73-5.48,3-8.24a12.5,12.5,0,0,1,5.78-6.55c2.58-1.28,5.31-1.77,7.66-2.79a10.489,10.489,0,0,0,3.12-2l.63-.63c.2-.22.37-.47.55-.7a9.654,9.654,0,0,0,.93-1.45,28.681,28.681,0,0,0,2.21-6c1-3.78,2.09-6.87,3.56-8.58a6.511,6.511,0,0,1,1-1.06c.16-.14.3-.28.44-.39l.41-.26a6.924,6.924,0,0,1,.77-.33Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6443",
    "data-name": "Path 6443",
    d: "M619.82,249.06a4.674,4.674,0,0,1,.06.85,10.478,10.478,0,0,1-.3,2.45,15.749,15.749,0,0,1-4.87,7.52,28.929,28.929,0,0,1-5,3.69c-1.93,1.14-4.06,2.23-6.25,3.47a32.287,32.287,0,0,0-6.38,4.49,24.64,24.64,0,0,0-4.84,6.79,62.108,62.108,0,0,1-4.19,7.39,17.66,17.66,0,0,1-2.74,3A16.537,16.537,0,0,1,582,290.9a39.9,39.9,0,0,1-6.69,2.57,60.009,60.009,0,0,0-5.88,2,22.509,22.509,0,0,0-4.48,2.4,13.872,13.872,0,0,0-2.81,2.59,12.851,12.851,0,0,0-1.69,2.8,5.282,5.282,0,0,1,.28-.81,10,10,0,0,1,1.25-2.12,13.469,13.469,0,0,1,2.8-2.7,22.829,22.829,0,0,1,4.51-2.5,60.009,60.009,0,0,1,5.89-2.05,41.381,41.381,0,0,0,6.6-2.58,17.05,17.05,0,0,0,3.15-2.12,17.742,17.742,0,0,0,2.64-2.94,64.32,64.32,0,0,0,4.15-7.34,24.83,24.83,0,0,1,5-6.92,32.228,32.228,0,0,1,6.5-4.54c2.2-1.23,4.33-2.3,6.26-3.43a28.873,28.873,0,0,0,5-3.58,15.86,15.86,0,0,0,4.92-7.31,15.284,15.284,0,0,0,.42-3.26Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6444",
    "data-name": "Path 6444",
    d: "M559.09,273a.752.752,0,0,1-.09-.2,5.206,5.206,0,0,1-.19-.59,4.781,4.781,0,0,1,.1-2.4c.56-2,2.77-4.57,6.33-5.84,1.78-.61,3.79-1,5.89-1.52a11.09,11.09,0,0,0,8.15-6.07,32.143,32.143,0,0,0,1.49-3.59,39.127,39.127,0,0,1,3.17-7.67,12.22,12.22,0,0,1,6.52-5.07,59.211,59.211,0,0,1,7.49-1.9,24.829,24.829,0,0,0,6.51-2.22,13.7,13.7,0,0,0,4.4-4,14.88,14.88,0,0,0,2.8-8.1,22.988,22.988,0,0,0-.21-3.2,10.41,10.41,0,0,1,.41,3.2,14.73,14.73,0,0,1-2.7,8.31,13.84,13.84,0,0,1-4.49,4.13,24.931,24.931,0,0,1-6.61,2.31,59.583,59.583,0,0,0-7.42,1.91,11.74,11.74,0,0,0-6.26,4.87,39.194,39.194,0,0,0-3.13,7.56,31.13,31.13,0,0,1-1.53,3.65,13.21,13.21,0,0,1-2.24,3.1,13,13,0,0,1-6.25,3.15c-2.12.54-4.12.88-5.87,1.46-3.47,1.18-5.67,3.61-6.26,5.55a5.069,5.069,0,0,0-.19,2.32,5,5,0,0,1,.18.85Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6445",
    "data-name": "Path 6445",
    d: "M616.12,327a3.827,3.827,0,0,1,.07.63,6.643,6.643,0,0,1-.19,1.8,10.21,10.21,0,0,1-3.78,5.4,16.672,16.672,0,0,1-4,2.36c-1.53.65-3.22,1.17-5,1.72a41.321,41.321,0,0,0-5.41,2A15.452,15.452,0,0,0,593,344.5c-1.46,1.52-2.72,3.19-4.12,4.67a18.768,18.768,0,0,1-4.61,3.6,20.31,20.31,0,0,1-9.51,2.48,18.939,18.939,0,0,1-6.54-1.09,12.485,12.485,0,0,1-1.66-.71,2.629,2.629,0,0,1-.55-.31,4.248,4.248,0,0,1,.59.21,17.719,17.719,0,0,0,1.68.62,20,20,0,0,0,6.48.91,20.211,20.211,0,0,0,9.28-2.53,18.681,18.681,0,0,0,4.47-3.53c1.37-1.46,2.62-3.12,4.11-4.68a16.058,16.058,0,0,1,5.08-3.7,41.392,41.392,0,0,1,5.49-2,52.307,52.307,0,0,0,5-1.66,16.77,16.77,0,0,0,3.9-2.25,10.2,10.2,0,0,0,3.81-5.16,12.7,12.7,0,0,0,.22-2.37Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6446",
    "data-name": "Path 6446",
    d: "M611.21,194.46l-8.34.2a13.49,13.49,0,0,1-1.88,4.73c-7-12.1-12.37-28.3-13.71-34.81.2-.65.43-1.37.72-2.17a9.24,9.24,0,0,0-.11-3.66c-.24-1.45-.64-3.4-.76-4.3-.37-2.76-.82-3.19-1.78-2.88-1.3.43.54,7.73-.53,7.89-.58.08-1.28-2.42-1.48-4.47s-1.14-8.37-1.81-8.79c-1-.62-1.87.36-1.61,2.4s.57,8.24-.51,8.33-2-10.39-2-10.39.17-2.28-1.09-2.23c-2.26.1-.49,11.14-.3,12.19.14.72-1,.86-1.14.07s-.66-10.47-3-10.39c-1.78,0,1.37,9.09.37,11.19s-1.68-7.12-3.37-7c-.63.05-1.1.17.06,5.38a118.184,118.184,0,0,0,4,12.21c2.68,14.45,14.44,60.68,32.87,52.22,10.32-4.74,14.5-25.72,14.5-25.72Z",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6447",
    "data-name": "Path 6447",
    d: "M575.66,157.2a.49.49,0,0,0,.24,0,.53.53,0,0,0,.37-.58c0-.62-.12-1.52-.26-2.69a37.549,37.549,0,0,1-.46-4.26c0-.84,0-1.74.05-2.69a9.9,9.9,0,0,1,.15-1.44c.08-.45.38-1,.73-.91h.06a.8.8,0,0,1,.74.68,3.92,3.92,0,0,1,.14,1.34h0a78.02,78.02,0,0,0,1.07,8.35c.08.37.16.75.28,1.13a4.288,4.288,0,0,0,.2.57,3.161,3.161,0,0,0,.17.3.55.55,0,0,0,.42.26.74.74,0,0,0,.63-.53,2.862,2.862,0,0,0,.19-.61,10.181,10.181,0,0,0,.16-1.22,36.446,36.446,0,0,0-.07-5,11.3,11.3,0,0,1-.1-2.51,1.4,1.4,0,0,1,.49-.93.53.53,0,0,1,.43-.05.819.819,0,0,1,.24.1.32.32,0,0,1,.11.15,12.75,12.75,0,0,1,.69,2.51c.18.88.33,1.79.47,2.7s.27,1.83.38,2.76a20.367,20.367,0,0,0,.46,2.85,11.012,11.012,0,0,0,.45,1.41,2.651,2.651,0,0,0,.42.71.59.59,0,0,0,.59.22.62.62,0,0,0,.41-.45,5,5,0,0,0,.11-1.56,14.311,14.311,0,0,0-.11-1.48c-.07-.84-.15-1.67-.18-2.49a9.678,9.678,0,0,1,0-1.21,2,2,0,0,1,.13-.52.489.489,0,0,1,.09-.15h.13c.66-.27.88.65,1.06,1.39s.25,1.58.41,2.37c.26,1.57.6,3.14.77,4.64a5.53,5.53,0,0,1-.08,2.16c-.24.72-.48,1.43-.71,2.14v.13a115.171,115.171,0,0,0,4.47,14.46c1.58,4.27,3.17,8,4.56,11s2.65,5.35,3.51,6.93l1,1.79a3.36,3.36,0,0,0,.39.6,4,4,0,0,0-.31-.64l-1-1.83c-.82-1.61-2-4-3.36-7s-2.9-6.73-4.44-11a119.4,119.4,0,0,1-4.38-14.42v.14c.23-.7.46-1.41.7-2.12a5.721,5.721,0,0,0,.12-2.39c-.18-1.57-.51-3.09-.77-4.67-.15-.78-.25-1.58-.41-2.4A4.4,4.4,0,0,0,587,152a1.18,1.18,0,0,0-.55-.56,1.27,1.27,0,0,0-.79,0h-.16a.65.65,0,0,0-.23.13.88.88,0,0,0-.25.35,2.261,2.261,0,0,0-.17.68,9.449,9.449,0,0,0,0,1.3c0,.84.12,1.68.19,2.52,0,.49.08,1,.1,1.45a4.859,4.859,0,0,1-.07,1.35c0,.1-.08.08,0,.13h0l-.06-.06a2,2,0,0,1-.3-.54,9.822,9.822,0,0,1-.43-1.33,18.59,18.59,0,0,1-.45-2.77q-.16-1.41-.39-2.79c-.14-.92-.3-1.82-.48-2.72a12.178,12.178,0,0,0-.76-2.67.851.851,0,0,0-.31-.35,1.727,1.727,0,0,0-.37-.16,1.11,1.11,0,0,0-.85.12,1.87,1.87,0,0,0-.74,1.3,4.85,4.85,0,0,0,0,1.37c0,.43.1.85.13,1.27a37.005,37.005,0,0,1,.09,4.92,8.527,8.527,0,0,1-.15,1.16,2.232,2.232,0,0,1-.15.52.609.609,0,0,1-.11.18c0,.09-.07,0-.06.12v-.13a2,2,0,0,1-.12-.21c-.07-.16-.13-.34-.19-.51-.11-.36-.19-.73-.27-1.09a79.476,79.476,0,0,1-1.13-8.28h0a4.352,4.352,0,0,0-.17-1.49,1.4,1.4,0,0,0-.39-.66,1,1,0,0,0-.74-.28h.06a.87.87,0,0,0-.87.41,2.21,2.21,0,0,0-.3.78,10.089,10.089,0,0,0-.14,1.5v2.72a34.887,34.887,0,0,0,.55,4.28c.17,1.16.3,2.06.36,2.67a.47.47,0,0,1-.29.52A1.511,1.511,0,0,0,575.66,157.2Z",
    fill: "#a36957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6448",
    "data-name": "Path 6448",
    d: "M510.53,208.23a21.411,21.411,0,0,0-5.79.67c-5.17,1.36-14.08,6.76-14.45,13.43h6.48s-3.63,7.72-2.57,7c2.77-1.86,8.27-7.45,8.27-7.45Z",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6449",
    "data-name": "Path 6449",
    d: "M598.86,92c-.15,0-.73-5.34-1.31-12s-.94-12-.8-12,.73,5.34,1.31,12S599,92,598.86,92Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6450",
    "data-name": "Path 6450",
    d: "M627.27,68.41c.11.08-4.26,6.43-9.77,14.18s-10.08,14-10.2,13.88,4.26-6.43,9.77-14.18S627.15,68.33,627.27,68.41Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6451",
    "data-name": "Path 6451",
    d: "M639.07,97.19c0,.14-5.08,1.31-11.4,2.61s-11.48,2.24-11.51,2.1,5.07-1.31,11.4-2.61S639,97.05,639.07,97.19Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6452",
    "data-name": "Path 6452",
    d: "M299,234.54l-35.4,181.8-4.6,23.8L495,439c10.6-.05,20-9.46,23.39-23.44l41.86-171.63c2.59-10.61-3.09-21.65-11.13-21.64l-238.92.25C305,222.53,300.34,227.45,299,234.54Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10794",
    "data-name": "Group 10794",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6453",
    "data-name": "Path 6453",
    d: "M299,234.54l-35.4,181.8-4.6,23.8L495,439c10.6-.05,20-9.46,23.39-23.44l41.86-171.63c2.59-10.61-3.09-21.65-11.13-21.64l-238.92.25C305,222.53,300.34,227.45,299,234.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6454",
    "data-name": "Path 6454",
    d: "M472.39,404l-25-201.41c-1-8.25-7.59-14.41-15.36-14.38l-54.8.17a15,15,0,0,0-10.83,4.8l-26,27.67-152.4.82c-9.31.05-16.47,8.87-15.24,18.77l23.21,186.15c1,8.24,7.59,14.39,15.34,14.38l265.65-.53c29.58.61,32.41-8.12,32.41-8.12C475.41,439.83,472.39,404.05,472.39,404Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10795",
    "data-name": "Group 10795",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6455",
    "data-name": "Path 6455",
    d: "M357.84,363.72l-8.96,9.62-69-62.08,8.96-9.62Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6456",
    "data-name": "Path 6456",
    d: "M345.13,299.51l9.9,8.91L292.6,375.47l-9.91-8.91Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6457",
    "data-name": "Path 6457",
    d: "M510.32,103.78a1.85,1.85,0,0,1-1.13-1.63l-.4-9.28a1.86,1.86,0,0,1,2.29-1.9,5.82,5.82,0,0,0,4.52-.89,5.21,5.21,0,0,0,2.33-3.42,5.33,5.33,0,0,0-1.12-4,6,6,0,0,0-3.94-2.37,7,7,0,0,0-7.1,5,1.87,1.87,0,0,1-3.6-1,10.76,10.76,0,0,1,11.13-7.77,9.66,9.66,0,0,1,6.49,3.83,9.13,9.13,0,0,1,1.83,6.87,9,9,0,0,1-4,5.92,9.72,9.72,0,0,1-5.06,1.65l.31,7.16a1.87,1.87,0,0,1-2.6,1.79Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6458",
    "data-name": "Path 6458",
    d: "M513.06,107.58a1.52,1.52,0,1,1-.519-1.05,1.53,1.53,0,0,1,.519,1.05Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6459",
    "data-name": "Path 6459",
    d: "M478.19,90.69a4.688,4.688,0,0,0,.09-.6c0-.44.11-1,.19-1.79a21.673,21.673,0,0,1,.49-2.88c.13-.56.2-1.18.4-1.81s.4-1.31.62-2a34.49,34.49,0,0,1,5-9.53,33.5,33.5,0,0,1,10.51-9.14,33,33,0,0,1,7.41-3.06,33.55,33.55,0,0,1,8.55-1.12A33.158,33.158,0,0,1,516,59c.77.08,1.53.28,2.3.41a17.121,17.121,0,0,1,2.3.56A32,32,0,0,1,529.49,64a33.44,33.44,0,0,1,13.22,16.6,32.74,32.74,0,0,1,2,11.41,32.161,32.161,0,0,1-2.09,11.74l-.45,1.14-.06.15.06.15c2.51,5.77,5,11.44,7.35,16.93l.42-.48-15-5.75-.18-.07-.15.14a32.973,32.973,0,0,1-41.14,3.97,34.171,34.171,0,0,1-8.43-7.85,33.21,33.21,0,0,1-6.4-15.34c-.12-1-.22-1.84-.31-2.6s0-1.38-.05-1.91a8.922,8.922,0,0,1,0-1.17.2.2,0,1,0-.06,0v3.1c0,.76.17,1.63.27,2.62a35.77,35.77,0,0,0,1.71,7.06,36.61,36.61,0,0,0,4.58,8.5,34.471,34.471,0,0,0,8.49,8A33.3,33.3,0,0,0,535,116.48l-.33.07,15,5.78.75.29-.33-.77c-2.38-5.49-4.84-11.15-7.34-16.93v.29l.46-1.17a32.7,32.7,0,0,0,2.14-12,33.45,33.45,0,0,0-2-11.66,34,34,0,0,0-13.51-16.91,32.3,32.3,0,0,0-9.12-4.1,15.892,15.892,0,0,0-2.34-.55c-.78-.14-1.55-.34-2.33-.41a34.391,34.391,0,0,0-4.61-.26,33.56,33.56,0,0,0-8.68,1.18,34.19,34.19,0,0,0-7.51,3.14,33.57,33.57,0,0,0-10.57,9.35,34.2,34.2,0,0,0-4.93,9.68c-.21.72-.41,1.41-.59,2a17.6,17.6,0,0,0-.38,1.83,19,19,0,0,0-.42,2.9c-.06.77-.1,1.36-.13,1.8A2.539,2.539,0,0,0,478.19,90.69Z",
    fill: "#263238"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.8fa39025df88d87e7242459f6b3747dc.svg";
export { ForwardRef as ReactComponent };